import Service from '../../../service/api';
import store from '../../store';
import router from '../../../router/index';

const TemplateModule = {
  namespaced: true,
  state: {
    allCourse: [],
    popUpData: [],
    popUpIntroData: [],
    popUpDataImage: [],
    popUpDataImageTwo: [],
    popUpData2: [],
    loading: false,
    checkingResult: true,
    point: 0,
    //// CPR /////
    templateContent: [],
    templateQuestion: [],
    templateModal: [],
    progress: [],
    courseView: [],
    progressData: [],
    userTemplate: [],
    lang: false,
    preposttest: {},
    assignmentTest: {},
    isChangeTemplate: false,
    historyTemplate: [],
    result: {},
    score: {},
    isTestOpen: true,
    changeTest: true,
    testTemplate: [],
    templateAndProgressData: [],
    lessonAndProgress: [],
    responseStatus: Object,
    sheetResultData: Object,
    flipCardData: Object,
    statusTest: Object,
  },
  mutations: {
    setPoint(state, res) {
      state.point++;
    },
    setTemplateData(state, res) {
      state.allCourse = res;
    },
    setPopUp(state, res) {
      state.popUpData = res;
    },
    setPopUpIntroData(state, res) {
      state.popUpIntroData = res;
    },
    setPopUpImage(state, res) {
      state.popUpDataImage = res;
    },
    setpopUpImageTwo(state, res) {
      state.popUpDataImageTwo = res;
    },
    setPopUp2(state, res) {
      state.popUpData2 = res;
    },
    loadingMutation(state) {
      state.loading = false;
    },
    turnOffLoadingMutation(state) {
      state.loading = true;
    },
    checkingTrueFalse(state, res) {
      state.checkingResult = res;
    },
    //// CPR /////
    setTemplateContent(state, res) {
      state.templateContent = res;
    },
    setTemplateQuestion(state, data) {
      state.templateQuestion = data;
    },
    setTemplateModal(state, data) {
      state.templateModal = data;
    },
    setProgress(state, data) {
      state.progress = data;
    },
    setCourseObj(state, data) {
      state.courseView = data;
    },
    setProgressData(state, res) {
      state.progressData = res;
    },
    setLangOption(state, data) {
      state.lang = data;
    },
    setUserTemplate(state, data) {
      state.userTemplate = data;
    },
    setPrePosttest(state, res) {
      state.preposttest = res;
    },
    setAssignmentTest(state, res) {
      state.assignmentTest = res;
    },
    setIsChangeTemplate(state) {
      state.isChangeTemplate = !state.isChangeTemplate;
    },
    setHistoryTemplate(state, res) {
      state.historyTemplate = res;
    },
    setCheckAnswer(state, res) {
      // state.result = res;
      if (res === undefined && state.result != 'test') {
        state.result = 'test';
      } else {
        state.result = res;
      }
    },
    setDisplayScore(state, res) {
      state.score = res;
    },
    setIsTestOpen(state, res) {
      state.isTestOpen = res;
    },
    setChangeTest(state) {
      state.changeTest = !state.changeTest;
    },
    setTestTemplate(state, res) {
      state.testTemplate = res;
    },
    setTemplateAndProgress(state, res) {
      state.templateAndProgressData = res;
    },
    setLessonAndProgress(state, res) {
      state.lessonAndProgress = res;
    },
    setResponseStatus(state, res) {
      state.responseStatus = res;
    },
    setSheetResultData(state, res) {
      state.sheetResultData = res;
    },
    setFlipCardData(state, res) {
      state.flipCardData = res;
    },
    setStatusTest(state, res) {
      state.statusTest = res;
    },
  },
  actions: {
    fetchTemplate({commit}, params) {
      Service.fetchTemplate(params)
        .then((res) => {
          commit('setTemplateData', res.data.data);
          commit('turnOffLoadingMutation');
        })
        .catch((err) => console.log(err));
    },
    fetchPopUp({commit}, params) {
      Service.fetchTemplate(params)
        .then((res) => {
          commit('setPopUp', res.data.data);
        })
        .catch((err) => console.log(err));
    },
    fetchPopUpIntroData({commit}, params) {
      Service.fetchTemplate(params)
        .then((res) => {
          commit('setPopUpIntroData', res.data.data);
        })
        .catch((err) => console.log(err));
    },
    fetchPopUpImage({commit}, params) {
      Service.fetchTemplate(params)
        .then((res) => {
          commit('setPopUpImage', res.data.data);
        })
        .catch((err) => console.log(err));
    },
    fetchpopUpImageTwo({commit}, params) {
      Service.fetchCourses(params)
        .then((res) => {
          commit('setpopUpImageTwo', res.data.data);
        })
        .catch((err) => console.log(err));
    },
    fetchPopUp2({commit}, params) {
      Service.fetchTemplate(params)
        .then((res) => {
          commit('setPopUp2', res.data.data);
        })
        .catch((err) => console.log(err));
    },
    ///// CPR /////
    fetchContent({commit}, body) {
      Service.fetchContent(body)
        .then((res) => {
          //console.log('xxxxxx',res.data.data.content.item);
          console.log('xxxxxx', res.data.data);
          commit('setTemplateContent', res.data.data);
          commit('setTemplateQuestion', res.data.data.content.question);
          //commit("setTemplateQuestion", res.data.data.content.item);
          commit('setIsTestOpen', true);
        })
        .catch((err) => {
          if (err.response.data.code == 40103) {
            commit('setIsTestOpen', false);
          }
        });
    },
    fetchModal({commit}, body) {
      Service.fetchContent(body)
        .then((res) => {
          commit('setTemplateModal', res.data.data);
        })
        .catch((err) => console.log(err));
    },
    orderContent({commit}, body) {
      body.content[body.contentIndex].order = body.min;
      commit('setTemplateContent', body.content);
    },
    getProgress({commit}, body) {
      Service.fetchProgress(body)
        .then((res) => {
          commit('setProgress', res.data.data);
        })
        .catch((err) => console.log(err));
    },
    saveProgress({commit}, body) {
      Service.saveProgress(body)
        .then((res) => {})
        .catch((err) => console.log(err));
    },
    setCourseView({commit}, body) {
      commit('setCourseObj', body);
    },
    setLangOption({commit}, value) {
      commit('setLangOption', value);
    },
    createUserTemplateData({commit}, body) {
      Service.createUserTemplate(body).then((res) => {
        commit('setUserTemplate', res.data);
      });
    },
    saveUserTemplateData({commit}, body) {
      // console.log("body =>",body);
      commit('loadingMutation');
      Service.saveUserTemplate(body)
        .then((res) => {
          commit('setCheckAnswer', res.data.displayAnswer);
          commit('turnOffLoadingMutation');
        })
        .catch((err) => {
          console.log('update err', err);
        });
    },
    fetchPrepostTestScore({commit}, body) {
      Service.getPrepostStatus(body)
        .then((res) => {
          localStorage.setItem('PretestScore', res.data.data.userscore);
          commit('setPrePosttest', res.data.data);
        })
        .catch((err) => {
          console.log('error');
          commit('setPrePosttest', undefined);
        });
    },
    fetchAssignmentTestScore({commit}, body) {
      Service.getAssignmentTest(body)
        .then((res) => {
          commit('setAssignmentTest', res.data.data);
        })
        .catch((err) => {
          console.log('error');
          commit('setAssignmentTest', undefined);
        });
    },
    fetchHistoryTemplate({commit}) {
      Service.getHistoryTemplate().then((res) => {
        commit('setHistoryTemplate', res.data.data);
      });
    },
    fetchScore({commit}, body) {
      Service.getScore(body)
        .then((res) => {
          commit('setDisplayScore', res.data.data);
        })
        .catch((err) => {
          console.log('error');
        });
    },
    fetchContentForCheckingPosttest({commit}, body) {
      Service.fetchContent(body)
        .then((res) => {
          commit('setIsTestOpen', true);
          commit('setChangeTest');
        })
        .catch((err) => {
          if (err.response.data.code == 40103) {
            commit('setIsTestOpen', false);
            commit('setChangeTest');
          }
        });
    },
    fetchTestTemplate({commit}, body) {
      Service.getTestTemplate(body)
        .then((res) => {
          commit('setTestTemplate', res.data.data);
        })
        .catch((err) => {
          console.log(err.response.data.code);
        });
    },
    fetchTemplateAndProgress({commit}, body) {
      Service.getTemplateAndProgress(body)
        .then((res) => {
          commit('setTemplateAndProgress', res.data);
        })
        .catch((err) => {
          console.log('Error', err.response.data);
          if (err.response.data.code == 40103) {
            console.log('API Not Authorize');
            alert('Test in this lesson has been locked.');
            alert('Please contract your teacher in section.');
            router.push('/LS01/1');
          } else {
            console.log('Error', err.response.data.code);
          }
        });
    },
    fetchLessonAndProgress({commit}, body) {
      Service.getLessonAndProgress(body)
        .then((res) => {
          commit('setLessonAndProgress', res.data);
        })
        .catch((err) => {
          console.log(`Error`, err.response.data);
        });
    },
    commitUserProgressChinese2({commit}, body) {
      Service.commitUserProgress(body)
        .then((res) => {
          if (res.data.code == 20000) {
            commit('setResponseStatus', res);
          }
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    fetchFlipCardChinese2({commit}, body) {
      Service.getFlipCardChinese2(body)
        .then((res) => {
          commit('setFlipCardData', res.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    fetchSheetResultChinese2({commit}, body) {
      Service.getSheetResultChinese2(body)
        .then((res) => {
          commit('setSheetResultData', res.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    fectchResultTestOpen({commit}, body) {
      Service.checkTestOpen(body)
        .then((res) => {
          commit('setStatusTest', res.data);
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
  },
  getters: {
    getPoint(state) {
      return state.point;
    },
    getTemplateData(state) {
      return state.allCourse;
    },
    getPopupData(state) {
      return state.popUpData;
    },
    getPopupIntroData(state) {
      return state.popUpIntroData;
    },
    getPopupDataImage(state) {
      return state.popUpDataImage;
    },
    getPopupDataImageTwo(state) {
      return state.popUpDataImageTwo;
    },
    getPopupData2(state) {
      return state.popUpData2;
    },
    loadingGetter(state) {
      return state.loading;
    },
    getCheckingResult(state) {
      return state.checkingResult;
    },
    ///// CPR /////
    getTemplateContent(state) {
      return state.templateContent;
    },
    getTemplateModal(state) {
      return state.templateModal;
    },
    getTemplateQuestion(state) {
      return state.templateQuestion;
    },
    getProgress(state) {
      return state.progress;
    },
    getCourseView(state) {
      return state.courseView;
    },
    getProgressData(state) {
      return state.progressData;
    },
    getLangOption(state) {
      return state.lang;
    },
    getUserTemplate(state) {
      return state.userTemplate;
    },
    getPrePostTest(state) {
      return state.preposttest;
    },
    getAssignmentTest(state) {
      return state.assignmentTest;
    },
    getIsChangeTemplate(state) {
      return state.isChangeTemplate;
    },
    getHistoryTemplate(state) {
      return state.historyTemplate;
    },
    getCheckAnswerResult(state) {
      return state.result;
    },
    getDisplayScore(state) {
      return state.score;
    },
    getTestStatus(state) {
      return state.isTestOpen;
    },
    getChangeTest(state) {
      return state.changeTest;
    },
    getTestTemplate(state) {
      return state.testTemplate;
    },
    getTemplateAndProgress(state) {
      return state.templateAndProgressData;
    },
    getLessonAndProgress(state) {
      return state.lessonAndProgress;
    },
    getResponseStatus(state) {
      return state.responseStatus;
    },
    getSheetResultData(state) {
      return state.sheetResultData;
    },
    getFlipCardData(state) {
      return state.flipCardData;
    },
    getStatusTest(state) {
      return state.statusTest;
    },
  },
};

export default TemplateModule;
